export default {
	data() {
		return {
			/**
			 * @vuese
			 *
			 * Whether show messenger when page loaded or not
			 *
			 * @type {Boolean}
			 */
			previewOnStart: true,
		}
	},
	methods: {
		/**
		 * @vuese
		 *
		 * Get Default Config
		 *
		 * @return  {Object|Null}
		 */
		getDefaultConfig() {
			return eval('typeof this.record') === 'object' && this.record.messenger_settings
				? {
						lang: this.record.messenger_settings.default_lang,
						logo: this.record.messenger_settings.logo,
						avatar: this.record.messenger_settings.avatar,
						mainColor: this.record.messenger_settings.main_color,
						size: {
							width: this.record.messenger_settings.width,
							height: this.record.messenger_settings.height,
						},
						headerBanner: this.record.messenger_settings.header_injector,
						voice: this.record.messenger_settings.voice,
						welcomeMsg: this.record.messenger_settings.welcome_msg,
						persistentMenu: this.record.chatbot_persistent_menus,
				  }
				: null
		},

		previewChanges(config = null) {
			config = config || this.getDefaultConfig()
			console.log('config', config)
			console.log('embed_code', this.embed_code)

			if (config && this.previewOnStart && this.embed_code) {
				window.postMessage(
					hj.json.stringify({
						cmd: 'toggle',
						config: {
							key: 'messenger_status',
							value: false,
						},
					}),
					'*'
				)

				this.$root.loadMessenger(this.embed_code, config, () => {
					setTimeout(
						() => {
							window.postMessage(
								window.hj.json.stringify({cmd: 'setConfig', config: {value: config}}),
								'*'
							)
						},
						this.$root.firstLoadFrame ? 1000 : 0
					)

					this.$root.firstLoadFrame = false

					setTimeout(
						() => {
							window.postMessage(
								window.hj.json.stringify({
									cmd: 'toggle',
									config: {
										key: 'messenger_status',
										value: true,
									},
								}),
								'*'
							)
						},
						this.$root.firstLoadFrame ? 1300 : 1000
					)
				})
			}
		},
	},
}
